import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';

import { AuthGuard } from './guards/auth.guard';

export const AppRoutes: Routes = [
  {
    path: '',
    component: AppBlankComponent,
    children: [
      {
        path: '',
        redirectTo: '/authentication/login',
        pathMatch: 'full',
      },
      {
        path: 'authentication',
        loadChildren: () =>
          import('./authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'instant-payment',
        loadChildren: () =>
          import('./instantpayment/instantpayment.module').then(
            (m) => m.InstantPaymentModule
          ),
      },
    ],
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./core/core.module').then(m => m.CoreModule),
      },
      {
        path: 'rocketmaster',
        loadChildren: () => import('./rocketmaster/rocketmaster.module').then(m => m.RocketmasterModule),
        canLoad: [AuthGuard],
        data: {
          requiredFeatures: ['access-rocketmaster-feature'],
        },
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
        canLoad: [AuthGuard],
        data: {
          requiredFeatures: ['access-reports-feature'],
        },
      },
      {
        path: 'statistics',
        loadChildren: () => import('./statistics/statistics.module').then(m => m.StatisticsModule),
        canLoad: [AuthGuard],
        data: {
          requiredFeatures: ['access-reports-feature'],
        },
      },
      {
        path: 'autoexport',
        loadChildren: () => import('./autoexport/autoexport.module').then(m => m.AutoExportModule),
        canLoad: [AuthGuard],
        data: {
          requiredFeatures: ['access-autoexport-feature'],
        }
      }
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/login',
  },
];
